module.exports = __webpack_public_path__ + "static/media/va.8aae3709.svg";